import { shallowEqual, useSelector } from 'react-redux'
import { useRouteMatch } from 'react-router'

import { IApplicationState } from '@store'
import {
  selectDisplayCampaignBudget,
  selectIsSocialCampaign,
  selectIsUnlockedCampaign,
} from '@store/campaigns'
import { selectCampaignId, selectCurrentDeclinedFilter } from '@store/router'
import { selectFilteredDeclinedSubmissionsLink } from '@store/submissions'

export const useInboxTopPanelData = () => {
  const match = useRouteMatch()
  const campaignId = selectCampaignId(match) as number

  return useSelector((state: IApplicationState) => {
    const currentDeclinedFilter = selectCurrentDeclinedFilter(state)
    return {
      campaignId,
      hasFilteredDeclinedLink: Boolean(
        selectFilteredDeclinedSubmissionsLink(
          state,
          campaignId,
          currentDeclinedFilter === 'all' ? undefined : currentDeclinedFilter,
        ),
      ),
      displayCampaignBudget: selectDisplayCampaignBudget(state, campaignId),
      isSocialCampaign: selectIsSocialCampaign(state, campaignId),
      isUnlockedCampaign: selectIsUnlockedCampaign(state, campaignId),
    }
  }, shallowEqual)
}
